import { useState } from 'react';
import { cn } from '@/lib/utils';
import { getOptimizedImageUrl, generateSrcSet, getImageSizes } from '@/lib/imageOptimizer';

interface OptimizedImageProps {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  priority?: boolean;
  className?: string;
  variant?: 'card' | 'hero' | 'thumbnail' | 'full';
  fallback?: string;
}

const OptimizedImage = ({
  src,
  alt,
  width = 800,
  height,
  priority = false,
  className,
  variant = 'card',
  fallback = '/placeholder.svg',
}: OptimizedImageProps) => {
  const [hasError, setHasError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  const optimizedSrc = hasError ? fallback : getOptimizedImageUrl(src, { width });
  const srcSet = hasError ? undefined : generateSrcSet(src);
  const sizes = getImageSizes(variant);

  return (
    <img
      src={optimizedSrc}
      srcSet={srcSet}
      sizes={sizes}
      alt={alt}
      width={width}
      height={height}
      loading={priority ? 'eager' : 'lazy'}
      decoding={priority ? 'sync' : 'async'}
      onError={() => setHasError(true)}
      onLoad={() => setIsLoaded(true)}
      className={cn(
        'transition-opacity duration-300',
        !isLoaded && 'opacity-0',
        isLoaded && 'opacity-100',
        className
      )}
    />
  );
};

export default OptimizedImage;
